import { useQSet } from '@exam-management/common/qset-provider';
import { ArrowBackOutlinedIcon, ArrowForwardOutlinedIcon, Button, Flex } from '@shared/components';

import { useQSetQuestionListSearchParams } from '../../hooks';

export default function QSetQuestionDetailsNavigatorActions() {
  const [{ page, pageSize }, { previousPage, nextPage, getPageSizeAsNumber }] =
    useQSetQuestionListSearchParams();
  const { qSet } = useQSet();
  const { qConfig } = qSet;
  const { totalQuestions } = qConfig;

  return pageSize !== 'All' ? (
    <Flex sx={{ gap: (theme) => theme.spacing(4) }}>
      <Button
        variant='outlined'
        color='secondary'
        startIcon={<ArrowBackOutlinedIcon />}
        onClick={() => {
          previousPage();
        }}
        disabled={page <= 0}
        sx={{ minWidth: '112px' }}
      >
        Previous
      </Button>
      <Button
        startIcon={<ArrowForwardOutlinedIcon />}
        onClick={() => {
          nextPage();
        }}
        disabled={page >= totalQuestions / getPageSizeAsNumber(pageSize) - 1}
        sx={{ minWidth: '112px' }}
      >
        Next
      </Button>
    </Flex>
  ) : null;
}
